import type { FileTypes } from "./ipm.types";

const SUBJECT = {
  policyDocuments:
    "Pending policy documents uploaded to policy number ${policyID}",
  requests: "${documentName} uploaded to policy number ${policyID}"
};

// Built-in (non-pac) forms
export const ACTIONS = [
  {
    label: "Change Customer",
    component: "ChangeCustomer",
    featureFlag: "ipm-change-customer"
  },
  {
    label: "Change Additional Interest",
    component: "ChangeAdditionalInterest",
    featureFlag: "ipm-additional-interest"
  },
  {
    label: "Upload Documents",
    component: "UploadDocuments"
  },
  {
    label: "Rescind Pending Cancellation",
    component: "RescindCancel",
    featureFlag: "ipm-rescind-pending-cancellation",
    enableForPolicies: ({ management }) =>
      management.PolicyState === "ACTIVEPOLICY" &&
      !!management.PendingCancellation
  },
  {
    label: "Resolve Inspection Conditions",
    component: "ResolveInspection",
    featureFlag: "ipm-resolve-inspection-conditions"
  }
];

export const EVENT_TYPES = {
  UPLOAD_POLICY_DOCUMENT: "UPLOAD_POLICY_DOCUMENT"
};

// Alphabetical
export const FILE_TYPES: FileTypes = {
  POLICY_CHANGE_REQUEST: {
    id: "Policy Change Request",
    label: "Policy Change Request",
    op: "OpPendingPolicyChangeRequest",
    updateFlag: false,
    zendeskSubject: SUBJECT.requests,
    zendeskTag: "POLICY_CHANGE_REQUEST"
  },
  ALARM_CERTIFICATE: {
    id: "Alarm Certificate",
    label: "Alarm Certificate",
    op: "OpPendingAlarmCertificate",
    updateFlag: true,
    zendeskSubject: SUBJECT.policyDocuments,
    zendeskTag: "ALARM_CERTIFICATE"
  },
  ANTI_ARSON: {
    id: "Anti-arson Application",
    label: "Anti-arson Application",
    op: "OpPendingAntiArsonForm",
    updateFlag: true,
    zendeskSubject: SUBJECT.policyDocuments,
    zendeskTag: "ANTI_ARSON_APP"
  },
  CANCELLATION_REQUEST: {
    id: "Cancellation Request",
    label: "Cancellation Request",
    op: "OpPendingCancellationRequest",
    updateFlag: false,
    zendeskSubject: SUBJECT.requests,
    zendeskTag: "CANCELLATION_REQUEST"
  },
  FLOOD: {
    id: "Flood Policy",
    label: "Flood Policy",
    op: "OpPendingFloodPolicy",
    updateFlag: true,
    zendeskSubject: SUBJECT.policyDocuments,
    zendeskTag: "FLOOD_POLICY"
  },
  FORTIFIED: {
    id: "Fortified Home",
    label: "Fortified Home",
    op: "OpPendingFortifiedHomeCertificate",
    updateFlag: true,
    zendeskSubject: SUBJECT.policyDocuments,
    zendeskTag: "FORTIFIED_HOME_CERT"
  },
  INSPECTION_DOCUMENT: {
    id: "Inspection document",
    label: "Inspection document",
    op: "OpInspectionDocument",
    updateFlag: false,
    zendeskSubject:
      "Pending policy documents uploaded to policy number ${policyID}",
    zendeskTag: "INSPECTION_DOCUMENT"
  },
  MORTGAGE_CHANGE_REQUEST: {
    id: "Mortgage Change Request",
    label: "Mortgage Change Request",
    op: "OpMortgageChangeRequest",
    updateFlag: false,
    zendeskSubject: SUBJECT.requests,
    zendeskTag: "MORTGAGE_CHANGE_REQUEST"
  },
  REINSTATEMENT_REQUEST: {
    id: "Reinstatement Request",
    label: "Reinstatement Request",
    op: "OpPendingReinstatementRequest",
    updateFlag: false,
    zendeskSubject: SUBJECT.requests,
    zendeskTag: "REINSTATEMENT_REQUEST"
  },
  SIGNED_INSURED_APPLICATION: {
    id: "Signed Insured Application",
    label: "Signed Insured Application",
    op: "OpSignedInsuredApplication",
    updateFlag: false,
    zendeskSubject: SUBJECT.requests,
    zendeskTag: "SIGNED_INSURED_APPLICATION"
  },
  SPP_APPRAISAL: {
    id: "SPP Appraisal",
    label: "SPP Appraisal",
    op: "OpPendingAppraisal",
    updateFlag: true,
    zendeskSubject: SUBJECT.policyDocuments,
    zendeskTag: "SPP_APPRAISAL"
  },
  OTHER: {
    id: "Other",
    label: "Other",
    op: "OpPendingOther",
    updateFlag: false,
    zendeskSubject: SUBJECT.requests,
    zendeskTag: "OTHER_DOCUMENT_TYPE"
  }
};

export const POLICY_CANCELED_STATE = {
  status: "CANCELLEDPOLICY",
  reason: "Insured Request"
};

export const CHANGE_ADDITIONAL_INTEREST_STATUS_TEXT = {
  SUCCESS: "Policy Change has been made.",
  ERROR_CHANGE_INTEREST:
    "There was a problem saving the additional interest.  Please try again.  If the problem continues, contact support.",
  ERROR_POST_NOTES:
    "Your Additional Interest request was saved, but there was a problem saving the Note.  Please check the policy to make sure all information is correct.  If the problem continues, contact support."
};

export const CHANGE_CUSTOMER_STATUS_TEXT = {
  SUCCESS: "Policy Change has been made.",
  ERROR_CHANGE_CUSTOMER:
    "There was a problem saving the customer change.  Please try again.  If the problem continues, contact support.",
  ERROR_POST_NOTES:
    "Your Policy Change Request was saved, but there was a problem saving the Note.  Please check the policy to make sure all information is correct.  If the problem continues, contact support."
};
